import { render } from "./MClinicsRemote.vue?vue&type=template&id=30b9d560"
import script from "./MClinicsRemote.vue?vue&type=script&lang=js"
export * from "./MClinicsRemote.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__